import { SettingsProps } from 'client/components/core/Sidebar/components/Settings/entities'
import React from 'react'
import { useIsAllowedWebsiteHeaderEntity } from 'src/editor/hooks/use-is-allowed-website-header-entity'
import { CommonButtonSettings } from 'src/editor/shared/settings/button/common-button-settings'
import { ButtonTypeGroup } from 'src/editor/shared/settings/groups/button-type-group'
import { WebsiteButtonEntityInterface } from 'src/shared/entities/website-button/website-button.schema'
import { WebsiteButtonActionsSettings } from './website-button-actions-settings'

export const WebsiteButtonSettings = ({
  entity,
  defaultEntity,
}: SettingsProps<WebsiteButtonEntityInterface>) => {
  const isAllowedWebsiteHeaderEntity = useIsAllowedWebsiteHeaderEntity(
    entity.parentId,
    entity.type,
  )

  return (
    <>
      <ButtonTypeGroup entity={entity} />
      <WebsiteButtonActionsSettings entity={entity} />
      <CommonButtonSettings
        entity={entity}
        defaultEntity={defaultEntity}
        hideDeviceAppearance={isAllowedWebsiteHeaderEntity}
      />
    </>
  )
}
